import MicroModal from 'micromodal';

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init({
        disableScroll: true, onClose: () => {
            document.querySelectorAll('[data-micromodal-trigger]').forEach(e => {
                (e as HTMLElement).blur();
            });
        },
    });
});

// Due to the mobile touch bug that exists in the MicroModal lib, we had to use the below
// to handle close modal function, the main point here is the stopPropagation on the click event
// eslint-disable-next-line @typescript-eslint/no-explicit-any
document.body.addEventListener('click', (evt: any) => {
    if (evt.target?.className?.includes('modal-overlay') || evt.target?.className?.includes('modal-close')) {
        evt.preventDefault();
        evt.stopPropagation();
        const modals = document.querySelectorAll('.modal');
        modals.forEach(element => {
            if (element.classList.contains('is-open')) {
                const hiddenClose = element.querySelector('.hidden-close');
                if (hiddenClose) {
                    (hiddenClose as HTMLDivElement).click();
                }
            }
        });
    }
}, false);
